// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mu-c";
export var backButton = "_mu-4";
export var backIcon = "_mu-5";
export var chevronShortcut = "_mu-6";
export var container = "_mu-1";
export var editor = "_mu-8";
export var editorWrapper = "_mu-7";
export var prefix = "_mu-2";
export var searchIcon = "_mu-3";
export var suffix = "_mu-9";
export var suffixContent = "_mu-a";
export var suffixText = "_mu-b";
export var wrapper = "_mu-0";